import { CardSelectBarChart } from "./src/elements/CardSelectBarChart";
import { CardReservoirSample } from "./src/elements/CardReservoirSample";
import Dog from "./src/elements/Dog";
import { Hero } from "./src/elements/Hero";
import { LogStream } from "./src/elements/LogStream";
import { RandomSelect } from "./src/elements/RandomSelect";
import { RandomShuffle } from "./src/elements/RandomShuffle";
import { CardReservoirSample2 } from "./src/elements/CardReservoirSample2";
import { SparkLines } from "./src/elements/SparkLines";
import { HighlightedWord } from "./src/elements/HighlightedWord";
import { CardOddsBarChart } from "./src/elements/CardOddsBarChart";
import { Card } from "./src/elements/Card";

async function main() {
  customElements.define("s-hero", Hero);
  customElements.define("s-dog", Dog);
  customElements.define("s-card-reservoir-sample", CardReservoirSample);
  customElements.define("s-card-reservoir-sample-2", CardReservoirSample2);
  customElements.define("s-random-shuffle", RandomShuffle);
  customElements.define("s-random-select", RandomSelect);
  customElements.define("s-card-select-bar-chart", CardSelectBarChart);
  customElements.define("s-card-odds-bar-chart", CardOddsBarChart);
  customElements.define("s-log-stream", LogStream);
  customElements.define("s-spark-lines", SparkLines);
  customElements.define("s-card", Card);
  customElements.define("h-", HighlightedWord);

  const msg = `
Ahoy! 👋

Thank you for taking an interest in how this post works. I put a lot of effort
into reducing the number of dependencies I use in my posts with this one, and
I got it down to just 1: matter-js for the hero "image." It's the first post
that uses the Web Animations API, and I have fallen completely in love with it.

You can find all of the code for this post at https://github.com/samwho/visualisations,
also feel free to open an issue if you have any questions or feedback.
  `;

  console.log(msg);
}

document.addEventListener("DOMContentLoaded", main);
